import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { RouterModule } from '@angular/router';
import { SwiperModule } from 'swiper/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MobileNavbarComponent } from './components/mobile-navbar/mobile-navbar.component';
import { TextLimitPipe } from '../pipes/text-limit.pipe';
import { ImageFormatPipe } from '../pipes/image-format.pipe';
import { CommaSepratedPipe } from '../pipes/comma-seprated.pipe';
import { BreadcrumbNavComponent } from './components/breadcrumb-nav/breadcrumb-nav.component';
import { RewardActivityDialogComponent } from '../reward-loyality/rewards/reward-activity-dialog/reward-activity-dialog.component';
import { AllRewardDialogComponent } from '../reward-loyality/rewards/all-reward-dialog/all-reward-dialog.component';
import { MaterialModule } from '../shared/material-module'
import { RecentActivtyOrderDialogComponent } from '../reward-loyality/rewards/recent-activty-order-dialog/recent-activty-order-dialog.component';
import { OrderCardComponent } from '../ordering/order-card/order-card.component'
import { LoginDialogComponent } from './components/login-dialog/login-dialog.component';
import { FilterDialogComponent } from '../ordering/filter-dialog/filter-dialog.component';
import { ApplyRewardDialogComponent } from '../ordering/apply-reward-dialog/apply-reward-dialog.component'
import { NoStoreSnackbarComponent } from '../ordering/no-store-snackbar/no-store-snackbar.component';
import { UploadImageService } from 'src/app/shared/services/upload-image.service';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { DataService } from '../core/services/data.service';
import { SharedDirectivesModule } from 'src/app/shared/shared-directives.module';
import { CardDetailComponent } from './components/card-detail/card-detail.component';
import { RemoveItemWarningComponent } from './components/remove-item-warning/remove-item-warning.component';
import { TimeformatPipe } from '../pipes/timeformat.pipe';
import { PriceformatPipe } from '../pipes/priceformat.pipe';
import { PaymentStatusDialogComponent } from 'src/app/shared/components/payment-status-dialog/payment-status-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';
import { ForceLogoutDialogComponent } from 'src/app/shared/components/force-logout-dialog/force-logout-dialog.component';
import { MatRippleModule } from '@angular/material/core';
@NgModule({
  declarations: [HeaderComponent,
    MobileNavbarComponent,
    TextLimitPipe,
    ImageFormatPipe,
    CommaSepratedPipe,
    BreadcrumbNavComponent,
    ApplyRewardDialogComponent,
    RewardActivityDialogComponent,
    AllRewardDialogComponent,
    FilterDialogComponent,
    RecentActivtyOrderDialogComponent,
    OrderCardComponent,
    LoginDialogComponent,
    NoStoreSnackbarComponent,
    ProductDetailComponent,
    CardDetailComponent,
    RemoveItemWarningComponent,
    TimeformatPipe,
    PriceformatPipe,
    PaymentStatusDialogComponent,
    SafeHtmlPipe,
    ForceLogoutDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SwiperModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedDirectivesModule,
    MatAutocompleteModule,
    MatRippleModule,
  ],
  exports: [HeaderComponent,
    TextLimitPipe,
    ImageFormatPipe,
    CommaSepratedPipe,
    MobileNavbarComponent,
    BreadcrumbNavComponent,
    ApplyRewardDialogComponent,
    RewardActivityDialogComponent,
    AllRewardDialogComponent,
    FilterDialogComponent,
    OrderCardComponent,
    LoginDialogComponent,
    NoStoreSnackbarComponent,
    ProductDetailComponent,
    SharedDirectivesModule,
    CardDetailComponent,
    RemoveItemWarningComponent,
    TimeformatPipe,
    PriceformatPipe,
    PaymentStatusDialogComponent,
    SafeHtmlPipe,
    ForceLogoutDialogComponent
  ],
  providers: [
    UploadImageService,
    DataService
  ]
})
export class SharedModule { }
